import React, {createContext, useContext} from 'react';
import PropTypes from 'prop-types';
import Honeybadger from '@honeybadger-io/js';
import TransactionalItemsApi from '../services/TransactionalItemsApi';
import MemberContext from './MemberContext';
import noop from '../utils/noop';

const Context = createContext({
  getRegistryItems: noop,
});

export default Context;

export const RegistryContextProvider = ({children}) => {
  const {member} = useContext(MemberContext);

  const getRegistryItems = async (theMember = member) => {
    if (!theMember) return null;
    let items;

    try {
      items = await TransactionalItemsApi.getRegistryItems({
        memberId: theMember.id,
      });
    } catch (err) {
      Honeybadger.notify(err, 'GetRegistryItemsError');
    }

    return items;
  };

  return (
    <Context.Provider
      value={{
        getRegistryItems,
      }}>
      {children}
    </Context.Provider>
  );
};

RegistryContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
